import React from 'react';
import { Helmet } from 'react-helmet';
import { Box } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { getCanonicalUrl } from '../utils/canonicalUrl';
import FreeAIAssessmentForm from '../components/FreeAIAssessmentForm';
import html from '../content/freeAiAssessment.html.js';

export default function FreeAIAssessment() {
  const location = useLocation();
  const canonicalUrl = getCanonicalUrl(location.pathname);
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Free AI Assessment - AI Capability & Use Case Discovery Questionnaire',
    description:
      'Complete this short questionnaire to receive a personalised snapshot of your organisation\u2019s AI readiness and opportunities. We\u2019ll email your report within 24 hours.',
    url: canonicalUrl,
  };
  return (
    <Box sx={{ '& form': { mt: 2 }, color: 'common.white' }}>
      <Helmet>
        <link rel="canonical" href={canonicalUrl} />
        <title>Free AI Assessment</title>
        <meta name="description" content="Request a free AI assessment and receive a personalised report." />
        <meta property="og:title" content="Free AI Assessment" />
        <meta property="og:description" content="Complete our questionnaire to identify AI opportunities in your business." />
        <meta property="og:image" content="/assets/visuals/re-profile-orange-ai-hud.webp" />
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>
      <Box
        component="img"
        src="/assets/visuals/re-profile-orange-ai-hud.webp"
        alt="Free AI assessment visual"
        sx={{ width: '100%', maxHeight: 300, objectFit: 'cover', mb: 2 }}
      />
      <div dangerouslySetInnerHTML={{ __html: html }} />
      <FreeAIAssessmentForm />
    </Box>
  );
}
